import MainRoutes from './MainRoutesContainer';

export default MainRoutes;
